import React from 'react'
import ReactPaginate from 'react-paginate'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'

import './Pagination.css'

const Pagination = ({ page, onPageChange }) => {
  return (
    <div className="pagination-container">
      { page > 1 ? (
        <ReactPaginate
          previousLabel={<span><FontAwesomeIcon icon={faChevronLeft} /></span>}
          nextLabel={<span><FontAwesomeIcon icon={faChevronRight} /></span>}
          breakLabel={'...'}
          breakClassName="break"
          pageCount={page}
          marginPagesDisplayed={2}
          pageRangeDisplayed={1}
          onPageChange={onPageChange}
          containerClassName="pagination-wrapper"
          activeClassName="active"
        />
      ) : null }
    </div>
  )
}

export default Pagination